import { STORIES1026_RESULTS } from "../actions/ActionType";

export const initialState = {
  types: []
};
export const stories1026Reducer = (type = initialState, action) => {
  switch (action.type) {
    case STORIES1026_RESULTS:
      return {
        stories1026: action.payload
      };
    default:
      return type;
  }
};
